module.exports = __webpack_public_path__ + "media/images/icons/follow-8c32bb583f5132556f5b0bfded1e9d5e.svg";